import { useTimeout } from '@fuse/hooks';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import { useState } from 'react';

const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		flex: 1,
		minHeight: '200px',
		padding: theme.spacing(4),
	},
	loadingContainer: {
		textAlign: 'center',
		maxWidth: '300px',
	},
	subtitle: {
		marginBottom: theme.spacing(4),
		opacity: 0.7,
	},
	pulseContainer: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		marginBottom: theme.spacing(3),
	},
	pulseDot: {
		width: '12px',
		height: '12px',
		borderRadius: '50%',
		// backgroundColor: theme.palette.primary.main,
		backgroundColor: theme.palette.secondary.value,
		margin: '0 4px',
		animation: '$pulse 1.4s ease-in-out infinite both',
		'&:nth-child(1)': { animationDelay: '-0.32s' },
		'&:nth-child(2)': { animationDelay: '-0.16s' },
		'&:nth-child(3)': { animationDelay: '0s' },
	},
	'@keyframes pulse': {
		'0%, 80%, 100%': {
			transform: 'scale(0)',
			opacity: 0.5,
		},
		'40%': {
			transform: 'scale(1)',
			opacity: 1,
		},
	}
}));

function FuseLoading(props) {
	const classes = useStyles();
	const [showLoading, setShowLoading] = useState(!props.delay);

	useTimeout(() => {
		setShowLoading(true);
	}, props.delay);

	if (!showLoading) {
		return null;
	}

	return (
		<div className="flex flex-1 flex-col items-center justify-center">

			<div className={classes.root}>
				<div className={classes.loadingContainer}>
					<Typography className="text-20 mb-16" color="textSecondary">
						Loading...
					</Typography>

					<div className={classes.pulseContainer}>
						<div className={classes.pulseDot} />
						<div className={classes.pulseDot} />
						<div className={classes.pulseDot} />
					</div>
				</div>
			</div>

		</div>
	);
}

FuseLoading.propTypes = {
	delay: PropTypes.oneOfType([PropTypes.number, PropTypes.bool])
};

FuseLoading.defaultProps = {
	delay: false
};

export default FuseLoading;